<template>
  <div>
    <el-carousel :height="computeHeight">
      <el-carousel-item v-for="(item, index) in sliders" :key="index">
        <img :src="item.img" class="slider_img" />
      </el-carousel-item>
    </el-carousel>
    <div class="solve head-label">
      <div style="text-align: center;" class="font_size_24">
        美业一站式解决方案
      </div>
    </div>
    <!-- 盒子 -->
    <div class="border_parent">
      <el-row :gutter="10">
        <el-col
          :xs="12"
          :sm="12"
          :md="6"
          v-for="(item, index) in images"
          :key="index"
        >
          <div class="border">
            <div class="border_img_parent">
              <img :src="item.img" class="img_border" />
            </div>
            <div class="border_title">{{ item.title }}</div>
            <div class="border_content_one">{{ item.content[0] }}</div>
            <div class="border_content_two">{{ item.content[1] }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 手机端商品展示 -->
    <div id="美业课堂" class="head-label">
      <div style="text-align: center;" class="font_size_24">
        美业课堂
      </div>
    </div>
    <div class="product_mobile">
      <el-row>
        <el-col :xs="24" :sm="12">
          <div
            class="product_mobile_content"
            style="padding-top: 50%;position: relative;"
          >
            <div
              style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;display: flex;
                        justify-content: center;align-items: center;flex-direction: column;"
            >
              <div class="product_mobile_title font_size_30">
                {{ products[0].title }}
              </div>
              <div
                class="product_font_style product_mobile_content_one"
                v-for="(content, index) in products[0].content"
                :key="index"
              >
                {{ content }}
              </div>
              <div class="wechat-applet">
                  <p>扫码即可进入微信小程序进行学习哦！</p>
                  <p><img src="../../static/other/xiaochengxu.jpg" style="width: 200px;" /></p>
                </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-row :gutter="20">
            <el-col span="12">
              <img :src="products[0].img[0].left" style="width: 100%;" />
            </el-col>
            <el-col span="12">
              <img :src="products[0].img[0].right" style="width: 100%;" />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <!-- 海报编辑器 -->
    <div id="海报编辑器" class="head-label">
      <div style="text-align: center;" class="font_size_24">
        花椒-海报编辑器
      </div>
    </div>
    <div class="product_pc">
      <el-row>
        <el-col :xs="24" :sm="12">
          <div class="product_pc_one">
            <div class="product_mobile_title font_size_30">
              {{ manages[0].title }}
            </div>
            <div style="margin-top: 20px" class="product_font_style">
              {{ manages[0].content[0] }}
            </div>
            <div style="margin-top: 10px" class="product_font_style">
              {{ manages[0].content[1] }}
            </div>
            <div style="margin-top: 10px" class="product_font_style">
              {{ manages[0].content[2] }}
            </div>
            <div style="margin-top: 10px" class="product_font_style">
              {{ manages[0].content[3] }}
            </div>
            <div style="margin-top: 10px" class="product_font_style">
              {{ manages[0].content[4] }}
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <img
            style="margin-top:30px;"
            :src="manages[0].img[0]"
            class="product_pc_img"
          />
        </el-col>
      </el-row>
    </div>
    <!-- AI创作工具 -->
    <div id="海报编辑器" class="head-label">
      <div style="text-align: center;" class="font_size_24">
        花椒-AI创作工具
      </div>
    </div>
    <div class="product_pc">
      <el-row>
        <el-col :xs="24" :sm="12">
          <div class="product_pc_one">
            <div class="product_mobile_title font_size_30">
              {{ aiTools[0].title }}
            </div>
            <div style="margin-top: 20px" class="product_font_style">
              {{ aiTools[0].content[0] }}
            </div>
            <div style="margin-top: 10px" class="product_font_style">
              {{ aiTools[0].content[1] }}
            </div>
            <div style="margin-top: 10px" class="product_font_style">
              {{ aiTools[0].content[2] }}
            </div>
            <div style="margin-top: 10px" class="product_font_style">
              {{ aiTools[0].content[3] }}
            </div>
            <div style="margin-top: 10px" class="product_font_style">
              {{ aiTools[0].content[4] }}
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <img
            style="margin-top:10px;"
            :src="aiTools[0].img[0]"
            class="product_pc_img"
          />
        </el-col>
      </el-row>
    </div>
    <!-- 产品特点-->
    <div id="产品特点" class="product_spec_title head-label">
      <div style="text-align: center;" class="font_size_24">
        产品特点
      </div>
    </div>
    <div class="product_spec_parent">
      <div class="border_one border_spec">
        <div class="border_spec_inner_one">
          <img :src="spec.product[0].img" style="width: 50px;height: 50px" />
          <div style="margin-left:5px; font-weight: bold;" class="font_size_24">
            {{ spec.product[0].title }}
          </div>
        </div>
        <div style="display: flex;flex-direction: column;">
          <div class="border_spec_content_one">
            {{ spec.product[0].contents[0] }}
          </div>
          <div class="border_spec_inner_last">
            {{ spec.product[0].contents[1] }}
          </div>
        </div>
      </div>
      <div>
        <img :src="computeArrowImg" class="border_spec_img" />
      </div>
      <div class="border_spec">
        <div class="border_spec_inner_one">
          <img :src="spec.product[1].img" style="width: 50px;height: 50px" />
          <div style="margin-left:5px; font-weight: bold;" class="font_size_24">
            {{ spec.product[1].title }}
          </div>
        </div>
        <div style="display: flex;flex-direction: column;">
          <div class="border_spec_content_one">
            {{ spec.product[1].contents[0] }}
          </div>
          <div class="border_spec_inner_last">
            {{ spec.product[1].contents[1] }}
          </div>
        </div>
      </div>
      <div>
        <img :src="computeArrowImg" class="border_spec_img" />
      </div>
      <div class="border_spec">
        <div class="border_spec_inner_one">
          <img :src="spec.product[2].img" style="width: 50px;height: 50px" />
          <div style="margin-left:5px; font-weight: bold;" class="font_size_24">
            {{ spec.product[2].title }}
          </div>
        </div>
        <div style="display: flex;flex-direction: column;">
          <div class="border_spec_content_one">
            {{ spec.product[2].contents[0] }}
          </div>
          <div class="border_spec_inner_last">
            {{ spec.product[2].contents[1] }}
          </div>
        </div>
      </div>
      <div>
        <img :src="computeArrowImg" class="border_spec_img" />
      </div>
      <div class="border_spec" style="margin-right: 0">
        <div class="border_spec_inner_one">
          <img :src="spec.product[3].img" style="width: 50px;height: 50px" />
          <div style="margin-left:5px; font-weight: bold;" class="font_size_24">
            {{ spec.product[3].title }}
          </div>
        </div>
        <div style="display: flex;flex-direction: column;">
          <div class="border_spec_content_one">
            {{ spec.product[3].contents[0] }}
          </div>
          <div class="border_spec_inner_last">
            {{ spec.product[3].contents[1] }}
          </div>
        </div>
      </div>
    </div>
    <!-- 关于我们-->
    <div id="关于我们" class="about_me head-label">
      <div style="text-align: center;" class="font_size_24">
        关于我们
      </div>
    </div>
    <div style="width: 90%;background-color: #F2F6FC;margin: 10px auto;">
      <div style="display: flex; flex-direction: column;width: 100%;">
        <p class="about_me_p">
          {{ company }}
          <span class="about_more" @click="aboutUs">了解更多>></span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Index",
  data() {
    return {
      sliders: [],
      images: [
        // {
        //   img: require("../../static/other/用户管理.png"),
        //   title: "用户管理",
        //   content: ["用户消费分析", "用户标签设定"],
        // },
        {
          img: require("../../static/other/品牌渠道.png"),
          title: "美业课堂",
          content: ["花椒创始人亲自授课", "精品课程等你来"],
        },
        {
          img: require("../../static/other/数据分析.png"),
          title: "素材中心",
          content: ["发圈素材不用愁", "你想要的都在这里"],
        },
        {
          img: require("../../static/other/用户构建.png"),
          title: "椒谈",
          content: ["美业心得，椒谈分享", "美业人自己的论坛"],
        },
        {
          img: require("../../static/other/店铺管理.png"),
          title: "店铺管理",
          content: ["商家专属后台", "收支清晰可见"],
        },
      ],
      products: [
        {
          img: [
            {
              left: require("../../static/other/kt01.jpg"),
              right: require("../../static/other/kt02.jpg"),
            },
            {
              left: require("../../static/other/3.jpg"),
              right: require("../../static/other/4.jpg"),
            },
            {
              left: require("../../static/other/5.jpg"),
              right: require("../../static/other/6.jpg"),
            },
          ],
          title: "美业课堂-微信小程序",
          content: [
            "花椒创始人亲自授课",
            "纹绣师拍摄剪辑进阶课程",
            "美甲美睫拍摄剪辑课程",
            "精品线下课：手把手教你玩转抖音小红书",
          ],
        },
      ],
      manages: [
        {
          img: [require("../../static/other/editor.png")],
          title: "花椒-海报编辑器",
          content: [
            "强大的在线海报编辑器，多种热门模板供你选择",
            "学习成本低，非常适用于新手小白,简单操作即可上手",
            "支持在线设计海报，免费下载海报图片",
            "可添加个人专属水印",
          ],
        },
      ],
      aiTools: [
        {
          img: [require("../../static/other/ai.jpg")],
          title: "花椒-AI创作工具",
          content: [
            "专为美业人打造的AI创作工具",
            "AI问答, 解决你的文案焦虑",
            "AI图生图, 打造高质量宣传图片",
            "AI赋能美业, 高质量作品从此触手可得",
            "学习成本低，非常适用于新手小白,简单操作即可上手",
          ],
        },
      ],
      spec: {
        img: require("../../static/other/arrow.png"),
        product: [
          {
            img: require("../../static/other/手指.png"),
            title: "一键建铺",
            contents: ["注册一键创建店铺", "开启您的专属店铺"],
          },
          {
            img: require("../../static/other/店铺管理.png"),
            title: "店铺装扮",
            contents: ["不同业态打造不同风格", "给用户流畅的视觉体验"],
          },
          {
            img: require("../../static/other/数据分析.png"),
            title: "营销分析",
            contents: ["多玩法提升品牌知名度", "优惠福利刺激付费转化"],
          },
          {
            img: require("../../static/other/助力零售.png"),
            title: "助力零售",
            contents: ["提供专业产品服务", "帮助线下零售业态提升营销"],
          },
        ],
      },
      company:
        "花椒视觉坚持以用户需求为导向，利用前沿科技打破传统美业教育与服务的边界，构建起线上线下一体化的学习与成长生态系统，旨在培养更多具备高技术水平的专业人才，同时也助力美业企业提升品牌影响力与核心竞争力，共同塑造美业行业的未来新貌。花椒视觉不仅是一个连接美业人的桥梁，更是推动整个行业走向数字化、智能化转型的重要引擎，通过其丰富多样的产品组合，为美业的无限可能提供技术支持。",
      carousel_height: "550px",
    };
  },
  methods: {
    aboutUs() {
      this.$router.push('/aboutUs')
      this.timer = setInterval(() => {
          let osTop = document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5)
          document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
          if (osTop === 0) {
              clearInterval(this.timer)
          }
      }, 30)
    },
  },
  mounted() {
    this.sliders = [
      {
        img: require("../../static/slider/01.png"),
      },
      {
        img: require("../../static/slider/02.png"),
      },
      {
        img: require("../../static/slider/03.png"),
      },
      {
        img: require("../../static/slider/04.png"),
      },
      {
        img: require("../../static/slider/05.png"),
      },
    ];
  },
  computed: {
    //计算高度
    computeHeight() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 415) {
        return "550px";
      } else {
        return "250px";
      }
    },
    computeArrowImg() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 450) {
        return require("../../static/other/arrow.png");
      } else {
        return require("../../static/other/arrow_down.png");
      }
    },
  },
};
</script>

<style scoped>
.border_parent {
  width: 90%;
  margin: auto;
}

.slider_img {
  height: 550px;
  width: 100%;
}

.solve {
  margin-top: 30px;
  margin-bottom: 10px;
}

.border {
  border-radius: 6px;
  border: 1px solid #ebeef5;
  height: auto;
  margin: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.border_one {
  margin-left: 0;
}

.border_img_parent {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.product_mobile_content {
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.product_mobile_img {
  width: 50%;
}

.product_mobile_title {
  font-weight: bold;
  text-align: center;
}

.product_pc_one {
  text-align: center;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.font_size_30 {
  font-size: 1.875em;
}

.product_font_style {
  font-size: 1.125em;
}

.product_pc_img {
  width: 100%;
}

.product_pc_img_div {
  width: 50%;
  float: left;
  display: flex;
  align-items: center;
}

.product_pc {
  display: flex;
  width: 90%;
  margin: 20px auto;
  background: #f2f6fc;
  align-items: center;
}

.product_spec_title {
  margin-top: 30px;
  margin-bottom: 10px;
}

.product_spec_parent {
  display: flex;
  width: 90%;
  margin: 20px auto;
  align-items: center;
  height: auto;
}

.cooperation_parent {
  display: flex;
  justify-content: center;
  width: 90%;
  margin: 20px auto;
  align-items: center;
  height: auto;
}

.border_spec {
  border-radius: 6px;
  border: 1px solid #ebeef5;
  float: left;
  width: 25%;
  height: auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.about_me_p {
  font-size: 1.25em;
  font-weight: normal;
  padding: 0 20px;
  margin: 10px;
  line-height: 50px;
  text-indent: 2em;
}

.border_title {
  font-family: "PingFang SC";
  margin-top: 10px;
  font-size: 1.125em;
  font-weight: bold;
  text-align: center;
}

.border_content_one {
  margin-top: 20px;
  font-size: 1.125em;
  text-align: center;
}

.border_content_two {
  margin-top: 5px;
  font-size: 1.125em;
  margin-bottom: 25px;
  text-align: center;
}

.img_border {
  margin-top: 15px;
  width: 80px;
  height: 80px;
}

.border_spec_inner_one {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 35px;
  height: 70px;
}

.border_spec_content_one {
  margin-top: 15px;
  font-size: 1.125em;
  float: left;
  text-align: center;
}

.border_spec_inner_last {
  margin-top: 15px;
  font-size: 1.125em;
  float: left;
  margin-bottom: 25px;
  text-align: center;
}

.cooperation {
  margin-top: 30px;
  width: 100%;
}

.about_me {
  display: flex;
  margin-top: 30px;
  justify-content: center;
  width: 100%;
}

.product_mobile {
  width: 90%;
  align-items: center;
  margin: 20px auto;
  background: #f2f6fc;
}

.product_mobile_img_div {
  width: 50%;
  height: auto;
}

.product_mobile_content_one {
  margin-top: 20px;
  text-align: center;
}

.product_mobile_content_two {
  margin-top: 10px;
  text-align: center;
}

.about_more {
  cursor: pointer;
  font-size: 16px;
  color: blue;
}

/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
  .slider_img {
    height: 250px;
    width: 100%;
  }

  .border_parent {
    display: flex;
    width: 90%;
    margin: auto;
    height: auto;
    flex-direction: column;
  }

  .border {
    border-radius: 6px;
    border: 1px solid #ebeef5;
    float: left;
    width: 100%;
    height: auto;
    margin: 10px 0 auto;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    /*background: aquamarine;*/
  }

  .border_img_parent {
    margin-top: 0;
  }

  .product_mobile {
    width: 90%;
    align-items: center;
    margin: 20px auto;
    height: auto;
    background: #f2f6fc;
  }

  .product_mobile_content {
    width: 100%;
    margin-top: 15px;
  }

  .product_mobile_content_one {
    margin-top: 5px;
  }

  .product_mobile_content_two {
    margin-top: 5px;
  }

  .product_mobile_img_div {
    display: flex;
    width: 100%;
    height: auto;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 15px;
  }

  .product_mobile_img {
    float: left;
  }

  .product_mobile_title {
    font-weight: bold;
  }

  .product_pc_one {
    width: 100%;
    margin-top: 15px;
  }

  .font_size_30 {
    font-size: 1.25em;
  }

  .product_font_style {
    font-size: 1em;
  }

  .product_pc_img {
    height: 280px;
    width: 320px;
  }

  .product_pc_img_div {
    width: 100%;
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
  }

  .product_pc {
    display: flex;
    width: 90%;
    height: auto;
    margin: 20px auto;
    background: #f2f6fc;
    flex-direction: column;
  }

  .head-label {
    display: flex;
    margin-top: 10px;
  }

  .product_spec_parent {
    display: flex;
    width: 90%;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    height: auto;
    flex-direction: column;
  }

  .border_spec {
    float: left;
    height: auto;
    margin: 8px;
    width: 100%;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .border_title {
    font-family: "PingFang SC";
    margin-top: 5px;
    font-size: 1.125em;
    font-weight: bold;
  }

  .border_content_one {
    margin-top: 5px;
    font-size: 1.125em;
  }

  .border_content_two {
    margin-top: 5px;
    font-size: 1.125em;
    margin-bottom: 8px;
  }

  .img_border {
    margin-top: 8px;
    width: 80px;
    height: 80px;
  }

  .border_spec_inner_one {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 8px;
    /*background-color: aqua;*/
    height: 70px;
  }

  .border_spec_content_one {
    margin-top: 5px;
    font-size: 1.125em;
    float: left;
  }

  .border_spec_inner_last {
    /*background-color: bisque;*/
    margin-top: 5px;
    font-size: 1.125em;
    float: left;
    margin-bottom: 8px;
  }

  .about_me {
    display: flex;
    margin-top: 10px;
    width: 100%;
  }
}

.border_spec_img {
  width: 75px;
  height: 55px;
  align-self: center;
}

.font_size_24 {
  font-size: 1.5em;
}

.wechat-applet {
  margin-top: 10px;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
